<div class="container-fluid px-0">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="contracts" *ngIf="contractUrl">
        <iframe width="100%" height="100%" [src]="contractUrl | safe:'resourceUrl'"></iframe>
      </div>
    </div>
  </div>
</div>

